import getPageData from "./getPageData";
import nameCityToCode from "./nameCityToCode";

export default async function (cityCode) {
  let pageData = await getPageData();

  let cityFinded = pageData.cityInfo.find(inf => {
    let codeCity = nameCityToCode(inf.nomeCidade);
    return codeCity === cityCode;
  });

  return !!cityFinded;
}
